import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Handicap = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M18.152 14.554A1.99 1.99 0 0 0 16.203 13H12v-3h3V8h-3V7h-2v6c0 1.103.897 2 2 2l4.196-.031.665 3.412A2.002 2.002 0 0 0 18.824 20H21v-2h-2.176l-.672-3.446z", key: "k0" }),
        React.createElement("circle", { cx: 11, cy: 4, r: 2, key: "k1" }),
        React.createElement("path", { d: "M9 20c-2.206 0-4-1.794-4-4 0-1.858 1.279-3.411 3-3.858V10.09c-2.833.478-5 2.943-5 5.91 0 3.309 2.691 6 6 6 2.967 0 5.432-2.167 5.91-5h-2.052c-.447 1.721-2 3-3.858 3z", key: "k2" })));
});
Handicap.displayName = 'Handicap';
export var HandicapDimensions = { height: 24, width: 24 };
